// extracted by mini-css-extract-plugin
export default {"reviews-container":"reviews_reviews-container__SlO9X","button-container":"reviews_button-container__Y88pc","icons":"reviews_icons__40iow","button":"reviews_button__Tr9Ez"};